<template>
  <div class="light crypto-source-select">
    <button
      v-for="item in list"
      :key="item"
      class="crypto-source-select__item"
      :class="{
        'crypto-source-select__item--active': item.value === props.value,
      }"
      @click="onSelect(item.value)"
    >
      {{ item.label }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { i18n } from '@kano/i18n';
import { WalletTypes } from '@/types';


const props = defineProps<{
  value: WalletTypes,
}>();

interface Options {
  label: string;
  icon: string;
  value: WalletTypes;
}

const list: Options[] = [
  {
    label: i18n.t('kano.exchange-form.tabs.paybis-wallet').toString(),
    icon: 'paybis-logo',
    value: WalletTypes.PAYBIS,
  },
  {
    label: i18n.t('kano.exchange-form.tabs.external-wallet').toString(),
    icon: 'wallet',
    value: WalletTypes.EXTERNAL,
  },
];

const emit = defineEmits<{
  (e: 'input', value: WalletTypes): void,
}>();

const onSelect = (value: WalletTypes) => {
  if (props.value === value) {
    return;
  }

  emit('input', value);
};
</script>

<style lang="scss" scoped>
.crypto-source-select {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  white-space: nowrap;
  gap: 2px;
  padding: 0 24px;
  margin-bottom: 20px;

  &__item {
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    padding: 4px 8px;
    border-radius: 6px;
    background: var(--color-base-4);
    border: none;
    cursor: pointer;

    &--active {
      background-color: var(--color-base);
      color: var(--color-base-0);
    }
  }
}
</style>
